import { initializeApp } from "firebase/app";

const app = initializeApp({
    apiKey:             "AIzaSyAx62q-xYAh9S2GNDhMP0oxrw9Tqqs6qQg",
    authDomain:         "homemoto-ph.firebaseapp.com",
    projectId:          "homemoto-ph",
    storageBucket:      "homemoto-ph.appspot.com",
    messagingSenderId:  "330344287473",
    appId:              "1:330344287473:web:d1bd3eec5e6c83a3652d50",
    measurementId:      "G-SLBLPKPQ2T"
});

export default app;